import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer,
  isOpen,
  onClick
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}) => {
  return <div className="border-b border-gray-800" data-id="element-41">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-42">
        <span className="text-lg md:text-xl font-medium text-white group-hover:text-primary transition-colors duration-300" data-id="element-43">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 45 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className={`flex-shrink-0 ml-4 ${isOpen ? 'text-primary' : 'text-gray-400'}`} data-id="element-44">
          <Plus size={24} data-id="element-45" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-46">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-47">
            <div className="pb-6 text-gray-400 text-base md:text-lg leading-relaxed" data-id="element-48">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿No me alcanza con Instagram?',
    answer: 'Instagram es visibilidad. La web es credibilidad y Google. Juntas, multiplican tus ventas. Separadas, te limitan.'
  }, {
    question: '¿Cuánto tarda en estar lista?',
    answer: '48 a 72 horas hábiles desde que me confirmás los datos. Sin esperas. Sin vueltas.'
  }, {
    question: '¿Funciona para mi rubro?',
    answer: 'Trabajo con todos los rubros. Cada web es diseñada específicamente para tu tipo de negocio.'
  }, {
    question: '¿Puedo modificarla después?',
    answer: 'Sí, yo no te abandono solo en la entrega, vas a tener mi servicio disponible todo el año para hacer las modificaciones que necesites.'
  }];
  return <section className="py-32 bg-background" data-id="element-49">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-50">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-51">
          Preguntas frecuentes
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-52">
          {faqs.map((faq, index) => <AccordionItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-53" />)}
        </motion.div>
      </div>
    </section>;
};